interface Config {
  apiEndpoint: string | undefined;
  awsRegion: string | undefined;
  userPoolId: string | undefined;
  userPoolClientId: string | undefined;
  userPoolDomain: string | undefined;
  signInUrl: string | undefined;
  signOutUrl: string | undefined;
  defaultEndpointName: string;
  workOrderStatusRefreshMilliseconds: number;
  logoMaxFileSizeInBytes: number;
  logoAllowedExtensions: string[];
  siteTimeoutValuesInMinutes: string[];
  siteContainerFillThresholdValues: string[];
  slaTimeHours: number[],
  slaTimeMinutes: number[],
  slaMaxTimes : number,
  slaMaxHourAndMinutesInDecimal: number,
  itemOrderTypes: string[],
  itemOrderStatuses: string[]
}

declare global {
  interface Window {
    config: Config;
  }
}

const configDefault: Config = {
  apiEndpoint: process.env.REACT_APP_HWRC_PORTAL_API_ENDPOINT,
  awsRegion: process.env.REACT_APP_AMPLIFY_AUTH_AWS_REGION,
  userPoolId: process.env.REACT_APP_AMPLIFY_AUTH_AWS_POOL_ID,
  userPoolClientId: process.env.REACT_APP_AMPLIFY_AUTH_AWS_WEB_CLIENT_ID,
  userPoolDomain: process.env.REACT_APP_AMPLIFY_AUTH_DOMAIN,
  signInUrl: process.env.REACT_APP_AMPLIFY_AUTH_REDIRECT_SIGN_IN,
  signOutUrl: process.env.REACT_APP_AMPLIFY_AUTH_REDIRECT_SIGN_OUT,
  defaultEndpointName: "sso",
  workOrderStatusRefreshMilliseconds: process.env.REACT_APP_WORK_ORDER_STATUS_REFESH_MILLISECONDS
    ? Number(process.env.REACT_APP_WORK_ORDER_STATUS_REFESH_MILLISECONDS)
    : 300000,
  logoMaxFileSizeInBytes: process.env.REACT_APP_LOGO_MAX_SIZE
    ? Number(process.env.REACT_APP_LOGO_MAX_SIZE!)
    : 2000000,
  logoAllowedExtensions: process.env.REACT_APP_LOGO_ALLOWED_EXTENSIONS
    ? process.env.REACT_APP_LOGO_ALLOWED_EXTENSIONS!.split(",")
    : ["gif", "jpg", "jpeg", "png"],
  siteTimeoutValuesInMinutes: process.env.REACT_APP_SITE_TIMEOUTS_IN_MINUTES
    ? process.env.REACT_APP_SITE_TIMEOUTS_IN_MINUTES!.split(",")
    : ["5", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55", "60"],
  siteContainerFillThresholdValues: process.env
    .REACT_APP_CONTAINER_FILL_THRESHOLD_VALUES
    ? process.env.REACT_APP_CONTAINER_FILL_THRESHOLD_VALUES!.split(",")
    : [
      "50",
      "55",
      "60",
      "65",
      "70",
      "75",
      "80",
      "85",
      "90",
      "95",
      "100"
    ],
  slaTimeHours: process.env.REACT_APP_SLA_HOURS
    ? process.env.REACT_APP_SLA_HOURS.split(",").map(Number)
    : [0, 1, 2, 3, 4, 5, 6, 7],
  slaTimeMinutes: process.env.REACT_APP_SLA_MINUTES
    ? process.env.REACT_APP_SLA_MINUTES.split(",").map(Number)
    : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
  slaMaxTimes: process.env.REACT_APP_SLA_MAX_TIMES ? Number(process.env.REACT_APP_SLA_MAX_TIMES) : 4,
  slaMaxHourAndMinutesInDecimal: process.env.REACT_APP_SLA_MAX_HOUR_AND_MINUTES_IN_DECIMAL
    ? Number(process.env.REACT_APP_SLA_MAX_HOUR_AND_MINUTES_IN_DECIMAL) : 7,
  itemOrderTypes: process.env.REACT_APP_ITEM_ORDER_TYPES ? process.env.REACT_APP_ITEM_ORDER_TYPES!.split(",")
    : ["Clothing", "Equipment", "Other"],
  itemOrderStatuses: process.env.REACT_APP_ITEM_ORDER_STATUSES ? process.env.REACT_APP_ITEM_ORDER_STATUSES!.split(",")
    : ["Raised", "Actioned", "Received", "Abandoned"]
};

function useConfig(): Config {
  // Check required as tests were failing
  if (window.config) {
    return {
      ...configDefault,
      ...JSON.parse(JSON.stringify(window.config))
    } as Config;
  }

  return configDefault;
}

export default useConfig;
